import { atom } from '@utils/state.utils';

export const tokenPermissions = atom<string[]>([]);

// make atom names more readable for debugging purposes
if (process.env.NODE_ENV !== 'production') {
  tokenPermissions.debugLabel = 'tokenPermissions';
}
